import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface CustomMarkdownProps {
    content: string | undefined;
}

export const CustomMarkdown = ({ content }: CustomMarkdownProps) => {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                h1: ({ node, ...props }) => (
                    <h1 style={{ letterSpacing: '0.05em', lineHeight: '1.6', marginTop: '30px' }} {...props} />
                ),
                h2: ({ node, ...props }) => (
                    <h2 style={{ letterSpacing: '0.05em', lineHeight: '1.6', marginTop: '20px' }} {...props} />
                ),
                h3: ({ node, ...props }) => (
                    <h3 style={{ letterSpacing: '0.05em', lineHeight: '1.6', marginTop: '20px' }} {...props} />
                ),
                h4: ({ node, ...props }) => (
                    <h4 style={{ letterSpacing: '0.05em', lineHeight: '1.6', marginTop: '20px' }} {...props} />
                ),
                h5: ({ node, ...props }) => (
                    <h5 style={{ letterSpacing: '0.05em', lineHeight: '1.6', marginTop: '20px' }} {...props} />
                ),
                h6: ({ node, ...props }) => (
                    <h6 style={{ letterSpacing: '0.05em', lineHeight: '1.6', marginTop: '20px' }} {...props} />
                ),
                p: ({ node, ...props }) => (
                    <p style={{ letterSpacing: '0.05em', lineHeight: '1.6' }} {...props} />
                ),
                ul: ({ node, ...props }) => (
                    <ul className='list-disc' {...props} />
                ),
                li: ({ node, ...props }) => (
                    <li style={{ letterSpacing: '0.05em', lineHeight: '1.6', marginLeft: '30px' }} {...props} />
                ),
            }}
        >
            {content}
        </ReactMarkdown>
    )
} 